//import {iconUrl} from 'data/icon'
import {ensureStatuses} from '../type'

export const BST = ensureStatuses({

})
